import { Headphones } from 'lucide-react';
import type { ReviewStamp } from '../../services/requests';

// A decision with no stamp was made by the DJ (ITER-194)
export function ReviewedByBadge({ reviewedBy }: { reviewedBy: ReviewStamp | null | undefined }) {
  if (!reviewedBy) return null;
  return (
    <span
      className="inline-flex items-center gap-1 mt-0.5 text-xs px-1.5 py-0.5 rounded bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300"
      title={`Reviewed by ${reviewedBy.name} (co-approval DJ)`}
    >
      <Headphones className="w-3 h-3" />
      by {reviewedBy.name}
    </span>
  );
}
